import logo from './logo.svg';
import './App.css';
import OnBoardingModule from './pages/OnBoardingModule/OnBoardingModule';

function App() {
  return (
    <OnBoardingModule/>
  );
}

export default App;
